/**
 * Download cross-origin images by fetching as blob
 * Handles CORS restrictions from Google Cloud Storage URLs
 *
 * @param {string} imageUrl - URL of the image to download
 * @param {string} filename - Desired filename for the download
 */
export async function downloadImage(imageUrl, filename) {
  try {
    // Fetch image as blob to bypass CORS download restrictions
    const response = await fetch(imageUrl)

    if (!response.ok) {
      throw new Error(`Failed to fetch image: ${response.status}`)
    }

    const blob = await response.blob()

    // Create object URL from blob (this is same-origin, so download works)
    const blobUrl = URL.createObjectURL(blob)

    // Create and click download link
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    // Clean up object URL to free memory
    URL.revokeObjectURL(blobUrl)
  } catch (error) {
    console.error('Download failed:', error)

    // Fallback: open in new tab if fetch fails
    window.open(imageUrl, '_blank')
  }
}
